import { useContext, useRef } from 'react'

import { Grid, TextField } from '@material-ui/core'

import ContentModalContext from '../../ContentModalProvider/Context'
import ValidationMessage from '../../components/ValidationMessage'
import { ERROR_MESSAGES, FIELD_NAMES, LABELS } from '../../components/constants'

const CreditAmount = (): JSX.Element | null => {
  const { item, onUpdateField, validation } = useContext(ContentModalContext)

  const touchedMinRef = useRef(false)
  const touchedMin = touchedMinRef.current
  const minError = touchedMin && !!validation.getHasError(LABELS.MIN_CREDITS)

  const touchedMaxRef = useRef(false)
  const touchedMax = touchedMaxRef.current
  const maxError = touchedMax && !!validation.getHasError(LABELS.MAX_CREDITS)

  const isCredit = item[FIELD_NAMES.CREDITS_AWARDED]

  return !isCredit ? null : (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={6}
      >
        <TextField
          fullWidth
          required
          variant="outlined"
          type="number"
          label={LABELS.MIN_CREDITS}
          placeholder={LABELS.MIN_CREDITS}
          error={minError}
          value={item[FIELD_NAMES.MIN_CREDITS]}
          onChange={(e) => {
            touchedMinRef.current = true
            // For error purposes only
            touchedMaxRef.current = true
            onUpdateField(FIELD_NAMES.MIN_CREDITS, parseInt(e.target.value))
          }}
        />
        <ValidationMessage
          label={LABELS.MIN_CREDITS}
          touched={touchedMin}
          valuesByError={{
            [ERROR_MESSAGES.REQUIRED]: item[FIELD_NAMES.MIN_CREDITS]?.toString(),
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
      >
        <TextField
          fullWidth
          required
          variant="outlined"
          type="number"
          label={LABELS.MAX_CREDITS}
          placeholder={LABELS.MAX_CREDITS}
          error={maxError}
          value={item[FIELD_NAMES.MAX_CREDITS]}
          onChange={(e) => {
            touchedMaxRef.current = true
            onUpdateField(FIELD_NAMES.MAX_CREDITS, parseInt(e.target.value))
          }}
        />
        <ValidationMessage
          label={LABELS.MAX_CREDITS}
          touched={touchedMax}
          valuesByError={{
            [ERROR_MESSAGES.REQUIRED]: item[FIELD_NAMES.MAX_CREDITS]?.toString(),
            [ERROR_MESSAGES.MAX_GREATER]: [item[FIELD_NAMES.MIN_CREDITS], item[FIELD_NAMES.MAX_CREDITS]],
          }}
        />
      </Grid>
    </Grid>
  )
}

export default CreditAmount
